import { render, staticRenderFns } from "./BroadcastCardItem.vue?vue&type=template&id=1dea26e6&scoped=true&"
import script from "./BroadcastCardItem.vue?vue&type=script&lang=ts&"
export * from "./BroadcastCardItem.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastCardItem.vue?vue&type=style&index=0&id=1dea26e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea26e6",
  null
  
)

export default component.exports